import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from '@cotyorg/ccx-atoms/Link';
import Picture from '@cotyorg/ccx-atoms/Picture';

const generateCardImageClassNames = ({ zoomOnHover, fixedHeight }) => classNames({
  'card__image': true,
  'card__image--fixed-height': fixedHeight,
  'card__image--zoom': zoomOnHover,
});

const generateCardImageWrapperClassNames = ({ extraImageCssClass, label }) => classNames({
  'card__image-wrapper': true,
  'card__image-wrapper--stacked-has-label grid-x align-center': label,
  [`${extraImageCssClass}`]: extraImageCssClass,
});

const ImageLinkElement = ({
  url,
  src,
  alt,
  srcset,
  cover,
}) => (
  <Link link={url}>
    <Picture
      alt={alt}
      src={src}
      srcset={srcset}
      cover={cover}
    />
  </Link>
);

ImageLinkElement.propTypes = {
  url: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  srcset: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  cover: PropTypes.bool,
};

const CardLabel = ({ label }) => <strong className="card__label">{label}</strong>;

CardLabel.propTypes = {
  label: PropTypes.string,
};

const CardImageElement = ({
  url,
  src,
  alt,
  srcset,
  cover,
}) => (
  url ? (
    <ImageLinkElement
      url={url}
      src={src}
      srcset={srcset}
      alt={alt}
      cover={cover}
    />
  ) : (
    <Picture
      src={src}
      srcset={srcset}
      alt={alt}
      cover={cover}
    />
  )
);

CardImageElement.propTypes = {
  url: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  srcset: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  cover: PropTypes.bool,
};

const CardImage = ({
  extraImageCssClass = false,
  src,
  srcset,
  url,
  label,
  alt,
  cover,
  zoomOnHover,
  fixedHeight,
}) => (
  <div className={generateCardImageClassNames({ zoomOnHover, fixedHeight })}>
    <div className={generateCardImageWrapperClassNames({ extraImageCssClass, label })}>
      {label && (
        <CardLabel label={label} />
      )}
      <CardImageElement
        alt={alt}
        url={url}
        src={src}
        srcset={srcset}
        cover={cover}
      />
    </div>
  </div>
);

CardImage.propTypes = {
  extraImageCssClass: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  src: PropTypes.string.isRequired,
  srcset: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  url: PropTypes.string,
  alt: PropTypes.string,
  label: PropTypes.string,
  cover: PropTypes.bool,
  zoomOnHover: PropTypes.bool,
  fixedHeight: PropTypes.bool,
};

export default CardImage;
